module.exports = __webpack_public_path__ + "img/registerUser-blog - Copy.cbe157f3.png";